import C from "./_common.js";
import g from "../../_styles/common/light.js";
import { changeColor as r } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/color/index.js";
function S(n) {
  const {
    borderColor: t,
    primaryColor: o,
    baseColor: e,
    textColorDisabled: a,
    inputColorDisabled: l,
    textColor2: i,
    opacityDisabled: b,
    borderRadius: d,
    fontSizeSmall: s,
    fontSizeMedium: u,
    fontSizeLarge: h,
    heightSmall: x,
    heightMedium: c,
    heightLarge: m,
    lineHeight: p
  } = n;
  return Object.assign(Object.assign({}, C), {
    labelLineHeight: p,
    buttonHeightSmall: x,
    buttonHeightMedium: c,
    buttonHeightLarge: m,
    fontSizeSmall: s,
    fontSizeMedium: u,
    fontSizeLarge: h,
    boxShadow: `inset 0 0 0 1px ${t}`,
    boxShadowActive: `inset 0 0 0 1px ${o}`,
    boxShadowFocus: `inset 0 0 0 1px ${o}, 0 0 0 2px ${r(o, {
      alpha: 0.2
    })}`,
    boxShadowHover: `inset 0 0 0 1px ${o}`,
    boxShadowDisabled: `inset 0 0 0 1px ${t}`,
    color: e,
    colorDisabled: l,
    colorActive: "#0000",
    textColor: i,
    textColorDisabled: a,
    dotColorActive: o,
    dotColorDisabled: t,
    buttonBorderColor: t,
    buttonBorderColorActive: o,
    buttonBorderColorHover: t,
    buttonColor: e,
    buttonColorActive: e,
    buttonTextColor: i,
    buttonTextColorActive: o,
    buttonTextColorHover: o,
    opacityDisabled: b,
    buttonBoxShadowFocus: `inset 0 0 0 1px ${o}, 0 0 0 2px ${r(o, {
      alpha: 0.3
    })}`,
    buttonBoxShadowHover: "inset 0 0 0 1px #0000",
    buttonBoxShadow: "inset 0 0 0 1px #0000",
    buttonBorderRadius: d
  });
}
const v = {
  name: "Radio",
  common: g,
  self: S
}, w = v;
export {
  w as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/radio/styles/light.js
// module id = 472
// module chunks = 41